export const profileLinks = (translation, isSubUser?: boolean) => {
  return [
    ...(isSubUser === true
      ? []
      : [
          {
            url: '/profile/details',
            name: translation.profile.myDetails,
            icon: 'profile-sidebar',
          },
        ]),

    {
      name: `${translation.profile.password}`,
      url: '/profile/password',
      icon: 'profile-key',
    },
    {
      name: `${translation.profile.debitors}`,
      url: '/profile/debitors',
      icon: 'expenses',
    },
    {
      name: `${translation.profile.creditors}`,
      url: '/profile/creditors',
      icon: 'incomes',
    },
    {
      name: `${translation.profile.managers}`,
      url: '/profile/managers',
      icon: 'new-manager',
    },
    {
      name: `${translation.profile.jobNumbers}`,
      url: '/profile/job-numbers',
      icon: 'new-job',
    },
    {
      name: `${translation.bankAdd.BankAccounts}`,
      url: '/profile/bank',
      icon: 'profile-bank',
    },
    ...(isSubUser === true
      ? []
      : [
          {
            url: '/profile/subuser',
            name: translation.subusers.SubUsers,
            icon: 'profile-subuser',
          },
        ]),
    ...(isSubUser === true
      ? []
      : [
          {
            name: `${translation.profile.payment}`,
            url: '/profile/payment',
            icon: 'profile-payment',
          },
        ]),
  ];
};
